/**
 * The segmented control — Traction / Hydro / MRL on room setup, and any other
 * short exclusive choice that has to be answerable without scrolling.
 *
 * Generic over the value so the room-type screen keeps `RoomType` end to end
 * instead of widening to `string` and casting back.
 */

import type { ReactNode } from 'react';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedProps<T extends string> {
  options: readonly SegmentedOption<T>[];
  value: T | undefined;
  onChange: (next: T) => void;
  /** Accessible name for the group. */
  ariaLabel: string;
  disabled?: boolean;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  disabled = false,
}: SegmentedProps<T>): ReactNode {
  return (
    <div className="seg" role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          className="seg__btn"
          aria-checked={value === option.value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
